/**
 * Antwort des Autodesk-Viewer-Endpunkts, wie sie Portal.Gui und CatalogManager.Gui verwenden.
 * Die GUIs nutzen diesen Typ statt des generierten `AutodeskViewerDto` aus den HttpClient-Models,
 * weil `fileInvalid` nur im Frontend existiert. Immer aus `@commonInterfaces/AutodeskViewerModel` importieren.
 */
export interface AutodeskViewerDto {
	token?: string | undefined;
	resourceIdentifier?: string | undefined;
	conversionFailed: boolean;
	/** Wird im Frontend gesetzt, wenn die API mit 409 antwortet – Autodesk hat die Datei abgelehnt. Kein Feld der API. */
	fileInvalid?: boolean;
}

/**
 * Ergebnis für eine 409-Antwort des Autodesk-Viewer-Endpunkts: Autodesk hat die Datei als fehlerhaft
 * abgelehnt. Der Viewer zeigt dafür einen eigenen Hinweis statt eines Fehler-Toasts.
 */
export function createFileInvalidAutodeskViewerDto(): AutodeskViewerDto {
	return { conversionFailed: true, fileInvalid: true };
}
